import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { AuthServiceGuest } from './../../services/AuthServiceGuest';
import { GuestsService } from './../../services/GuestsService';

import { Subscription, SubscribersGetResponse } from './../../dataTypes/Subscription';
import { CurrentUser } from './../../dataTypes/CurrentUser';

import { LanguageService } from './../../services/LanguageService';
import { LanguageConstants } from './../../common/language/LanguageConstants';
import { EditSubscriberDialog } from './saveSubscriber/editSubscriber.dialog';

import * as _ from 'lodash';
import { MatDialog, MatDialogRef, MatPaginator, PageEvent } from '@angular/material';
import { createEditSubscriberModel } from '../../dataTypes/createEditSubscriberModel';
import { MessageToUserDialog } from '../../shared/dialog/messageToUser.dialog';
import { ParkForReservedSubscriber } from '../../dataTypes/ParkForReservedSubscriber';
import { Park } from '../../dataTypes/Park';
import { MaxSubscribersToCreatePerPark } from '../../dataTypes/MaxSubscribersToCreatePerPark';
import { SubscribersWithDestinedParkAmounts } from '../../dataTypes/SubscribersWithDestinedParkAmounts';
import { AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment.prod';

import { MobileStatusService } from '../../services/MobileStatusService';
import * as moment from 'moment';


@Component({
    selector: 'subscriptions',
    templateUrl: './Subscriptions.html',
    styleUrls: ['./subscriptions.component.css'],
})
export class Subscriptions implements AfterViewInit
{

    public language = 'en';
    public languageConstants = LanguageConstants['en'];
    public rtl = false;



  displayedColumns: string[] = [];
  //  'firstName', 'lastName', 'carNumber', 'carNumber2', 'startDate', 'finishDate', 'phone', 'isReserved', 'reservedPark', 'isInSite', 'parkDescription', 'EntranceDate', 'editSubscriberAction', 'deleteSubscriberAction'];
 
  public _subscribersList: Subscription[];
  public _selectedSubscriber: Subscription;
  public _parkForReservedSubscriberList: ParkForReservedSubscriber[];
  public _searchByLPRNumber: string;
  public _filterInSiteOnly: boolean;

  public counting = {
      "reservedPlaces": 0,
      "freePlaces": 0,
      "guestsCount": 0,
      "subscribersCount": 0,
      "constSubscribersCount": 0
  };

  public _ShowNotification: boolean = false;
  public _ErrorClass: string;
  public _ErrorMessage: string;
  public _ErrorLangConst: boolean;

  public user: CurrentUser = new CurrentUser();

  public _errorFromServer: string;
  public _isAtidim: boolean;
  public _isMobile: boolean = false;
 
 
  public _parksList: Park[];
  public _selectedPark: number;

  public _maxSubscribersToCreatePerParkList: MaxSubscribersToCreatePerPark[];
  public _subscribersWithDestinedPark: SubscribersWithDestinedParkAmounts[];
  public _subscribersAmoutToCreateString: string;
  public _subscribersAmoutToCreateTotal: number;
  public _subscribersAmoutLeftToCreateTotal: number;
  public _subscribersAmoutLeftToCreateString: string;
 

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  public _totalSubscribers: number;
  public _amountPerSearch: number;
  public _pageNumber: number;
  public _pageSize: number;

  public _AfterEmptySearch: boolean;

  //-----------------------------------------------------------------------------

  useMobileByForce: boolean = environment.useMobileOnly;

  public _showEditSubscriptionDialog: boolean = false;

  public _isNewSubscriber: boolean = false;

  @ViewChild('subscribersTable', { static: true }) subscribersTable!: ElementRef;

  _EditSubscriberDialogModel: EditSubscriptionModel;

  public _selectedAction: SubscriptionAction = SubscriptionAction.None;

  //---------- transferred from editSubscriber.dialog.ts variables --------------
  public _startDate: Date;
  public _endDate: Date;
  public _errorString: string;

  public _selectedDestinedPark: number;
  public _originalSubscriberDestinedPark: number;
  public _originalSubscriberReservedPark: number;
  public _canPopulateReservedCombos: boolean;
  //-----------------------------------------------------------------------------

  public _screenSize: { width: number; height: number } = {
    width: 0,
    height: 0
  };

  private dialogRef: MatDialogRef<EditSubscriberDialog> | undefined;

  public _isVertical: boolean = false; // Add the isVertical flag Horizontal
  public _isRealyMobileDevice: boolean = false;

  private _lastCompany: number = 0;

  constructor(private _language: LanguageService,
              public _GuestsService: GuestsService,
              private _AuthService: AuthServiceGuest,
              public _dialog: MatDialog,
              private datePipe: DatePipe,
              private cdr: ChangeDetectorRef,
              private mobileStatusService: MobileStatusService ) {

      this._language.language$.subscribe(
          language => {
              this.language = language;
              this.languageConstants = LanguageConstants[this.language];
          });
      this._language.rtl$.subscribe(
          rtl => {
              this.rtl = rtl;
        });

      //---------------

      this._EditSubscriberDialogModel = {
        subscription: new Subscription(
          /*userId ?:*/ null,
          /*menuimNo ?: */ null,
          /*name ?:*/ '',
          /*lastName ?: */ '',
          /*companyName ?: */ '',
          /*menuimCarNo ?: */ '',
          /*menuimCarNo2 ?: */ '',
          /*insidePark ?: */ null,
          /*menuimStartDate ?: */ '',
          /*menuimEndDate ?: */ '',
          /*isReservedPlace ?: */ false,
          /*reservedParkID ?: */ null,
          /*sitesList ?: */ [],
          /*parkEntranceDate ?: */ '',
          /*parkDescription ?: */ '',
          /*parkNumber ?: */ null,
          /*phone ?: */ '',
          /*destinedPark ?: */ null
    
        ),
      
        parksForReservedSubscriber: [],
        parksForDestinedSubscriber: [],
        isEdit: false,
        isAtidim: false,
        maxSubscribersToCreatePerParkList: [],
        subscribersWithDestinedPark: []
    
      };
    //---------------
  }
   
  ngOnInit(): void
  {

    this.updateOrientation();
    window.addEventListener('resize', this.updateOrientation.bind(this));

    const self = this;
    self._isAtidim = true;
   
    this._totalSubscribers = 10000;
    this._pageNumber = 1;
    this._pageSize = 6;

    self.user = self._AuthService.getUserInfo();

    // start load after any company selected
    self._GuestsService.selectedCompanySubject.subscribe(
      data => {
        if (data) {
          self.parks();
          self.getCounting();
          self.getSubscribersList('');
          self.getParksForReservedSubscriber();
        }

      }
    );

    if (self._GuestsService._selectedCompany) {
      self.parks();
      self.getCounting();
      self.getSubscribersList('');
      self.getParksForReservedSubscriber();
    }
  }

  _isOdd(index: number): boolean {
    return index % 2 !== 0;
  }

  ngAfterViewInit(): void {
    //+++++++++++++++
    this._isRealyMobileDevice = this.isRealyMobileDevice();
    console.log('Subscriptions ngAfterViewInit isRealyMobileDevice ' + this._isRealyMobileDevice);
    //+++++++++++++++

    this._isMobile = this.isMobileDevice();
    /////this._isMobile = (this.useMobileByForce === false) ? window.matchMedia('(max-width: 767px)').matches : true;
    /////this._isMobile = window.matchMedia('(max-width: 767px)').matches;
    /////this._isMobile = true; // true ->> for similate on PC the Mobile version
    console.log('ngAfterViewInit Device ' + this._isMobile ? 'Mobile' : 'Desktop');

    this.displayedColumns = [];
    this._pageNumber = 1;

    //this.displayedColumns = (this._isMobile === true) ? ['lastName', 'divider1', 'carNumber', 'divider2', 'finishDate']
    //  : ['companyName', 'firstName', 'lastName', 'carNumber', 'carNumber2', 'startDate', 'finishDate', 'phone', 'destinedPark', 'isReserved', 'reservedPark', 'isInSite', 'parkDescription', 'EntranceDate',
    //    'editSubscriberAction', 'deleteSubscriberAction'
    //  ];

    //-----------transferred from editSubscriber.dialog.ts---------
    if (this._isMobile === true) {
      this.displayedColumns = ['lastName', 'divider1', 'carNumber', 'divider2', 'finishDate'];

      this._canPopulateReservedCombos = false;

      this._originalSubscriberDestinedPark = 0;

      if (this._EditSubscriberDialogModel.parksForReservedSubscriber.length > 0) {

        let parksForReservedSubscriber: ParkForReservedSubscriber[] = [];

        this._EditSubscriberDialogModel.parksForReservedSubscriber.forEach((element, index) => {
          if (parksForReservedSubscriber.findIndex(x => x.id == element.id) === -1) {
            parksForReservedSubscriber.push(element);
          }
        });

        this._EditSubscriberDialogModel.parksForReservedSubscriber = parksForReservedSubscriber;
        this._canPopulateReservedCombos = true;

        this._selectedPark = this._EditSubscriberDialogModel.parksForReservedSubscriber[0].id;

        if (this._EditSubscriberDialogModel.isAtidim === true) {

          let parksForDestinedSubscriber: ParkForReservedSubscriber[] = [];


          this._EditSubscriberDialogModel.parksForDestinedSubscriber.forEach((element, index) => {
            if (parksForDestinedSubscriber.findIndex(x => x.id == element.id) === -1) {
              parksForDestinedSubscriber.push(element);
            }
          });

          this._EditSubscriberDialogModel.parksForDestinedSubscriber = parksForDestinedSubscriber;

          this._selectedDestinedPark = this._EditSubscriberDialogModel.parksForDestinedSubscriber[0].id;

        }
      }

      if (this._EditSubscriberDialogModel.isEdit === false) { // new

        this._EditSubscriberDialogModel.subscription.isReservedPlace = false;

        this._startDate = new Date();
        this._endDate = new Date();
        this._endDate.setMonth(this._startDate.getMonth() + 1); // add month day to today
      //  var monthShift = this._startDate.getMonth();
      //  this._startDate.setMonth(monthShift);
      //  this._endDate.setMonth(monthShift + 1); // add month day to today
      }
      else { // edit


        this._originalSubscriberDestinedPark = this._EditSubscriberDialogModel.subscription.destinedPark;
        this._originalSubscriberReservedPark = this._EditSubscriberDialogModel.subscription.reservedParkID;

        if (this._EditSubscriberDialogModel.subscription.isReservedPlace && this._EditSubscriberDialogModel.subscription.reservedParkID > 0) {
          this._selectedPark = this._EditSubscriberDialogModel.parksForReservedSubscriber.filter(x => x.id === this._EditSubscriberDialogModel.subscription.reservedParkID)[0].id;
        }

        if (this._EditSubscriberDialogModel.subscription.destinedPark > 0) {
          this._selectedDestinedPark = this._EditSubscriberDialogModel.parksForDestinedSubscriber.filter(x => x.id === this._EditSubscriberDialogModel.subscription.destinedPark)[0].id;
        }

        this._startDate = new Date(this._EditSubscriberDialogModel.subscription.menuimStartDate);
        this._endDate = new Date(this._EditSubscriberDialogModel.subscription.menuimEndDate);


        if (this._EditSubscriberDialogModel.isAtidim === true && this._EditSubscriberDialogModel.subscription.destinedPark) {
          this._selectedDestinedPark = this._EditSubscriberDialogModel.parksForDestinedSubscriber.find(x => x.id === this._EditSubscriberDialogModel.subscription.destinedPark).id;

          if (!this._selectedDestinedPark) {

            this._selectedDestinedPark = this._EditSubscriberDialogModel.parksForDestinedSubscriber[0].id;

          }
        }


        if (this._EditSubscriberDialogModel.subscription.isReservedPlace === true) {
          this._selectedPark = this._EditSubscriberDialogModel.parksForReservedSubscriber.find(x => x.id === this._EditSubscriberDialogModel.subscription.reservedParkID).id;
          if (!this._selectedPark) {
            this._selectedPark = this._EditSubscriberDialogModel.parksForReservedSubscriber[0].id;
          }
        }

      }
    }
    else {
      this.displayedColumns = (this.user.permission === 1)
        ? ['companyName', 'firstName', 'lastName', 'carNumber', 'carNumber2', 'startDate', 'finishDate', 'phone', 'destinedPark', 'isReserved', 'reservedPark', 'isInSite', 'parkDescription', 'EntranceDate']
        : ['companyName', 'firstName', 'lastName', 'carNumber', 'carNumber2', 'startDate', 'finishDate', 'phone', 'destinedPark', 'isReserved', 'reservedPark', 'isInSite', 'parkDescription', 'EntranceDate',
          'editSubscriberAction', 'deleteSubscriberAction'
        ];
      console.debug('subscriptions ngAfterViewInit user.permission ' + this.user.permission);
    }
    //-----------transferred from editSubscriber.dialog.ts---------

    //^^^^^^^^^^^^^^^^^^^^^
    setTimeout(() => {
      this._isMobile = this.isMobileDevice();
      this.mobileStatusService.setMobileStatus(this._isMobile);
    }, 0);
    //^^^^^^^^^^^^^^^^^^^^^

    this.cdr.detectChanges();

  }



  //+++++++++++++++++++++++++++++
  private isRealyMobileDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      /android|webos|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent)
    );
  }
  //+++++++++++++++++++++++++++++


  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any): void {
    ///this.updateScreenWidth();
    if (!this._isRealyMobileDevice) {
      console.log('Subscriptions onWindowResize reload ' + event);

      location.reload();
    }    
  }

  updateOrientation() {
    this._isVertical = window.matchMedia('(orientation: portrait)').matches;

    //^^^^^^^Need chack ^^^^^^
    this._isRealyMobileDevice = this.isRealyMobileDevice();
    console.log('UpdateOrientation ' + this._isRealyMobileDevice);

    this._isMobile = this.isMobileDevice();
    //^^^^^^^^^^^^^^^

  }

  getScreenSize() {
    this._screenSize = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }


  isMobileDevice(): boolean {

    this.getScreenSize();
    console.debug(this._screenSize);

    return this._isRealyMobileDevice ? true
      : this.useMobileByForce === false ? this._screenSize.width < this._screenSize.height
        : true;
  }

  ngOnDestroy() {
    console.debug('Subscribers ngOnDestroy ');

    this._isNewSubscriber = false;
    if (this._isMobile) {
      document.removeEventListener('click', this.onOutsideClick.bind(this));
    }
  }


  getUserPermissionStyles(): any {

    const styles = {
      'text-align': 'center'
    };

    //styles['background-color'] = 'red';

    if (this.user.permission !== 0) {

      styles['transform'] = 'scale(1.75)';

      if (this._isMobile) {
        styles['padding-top'] = '15px';
        styles['padding-right'] = '15px';
      }
      else {
        styles['padding-bottom'] = '30px';
        styles['padding-right'] = '60px';
      }

      if (this._GuestsService._selectedCompany.id === 1) {
        styles['opacity'] = '0.5';
        styles['pointer-events'] = 'none';
      }

      return styles;
    }
  }

  getForcePadding(): any {
    if (this.user.permission !== 0) {
      return {
        'padding-right': '20px',
      }
    }
  }

  desableWhenNonSelectedCompany() {
    const styles = {

    };

    if (this._GuestsService._selectedCompany.id === 1) {
      styles['opacity'] = '0.5';
      styles['pointer-events'] = 'none';
    }

    return styles;
  }
  //-----------------------------

  private setColumnsAccordingToAtidimAndUserPermissions() {


    const self = this;

    this.displayedColumns = [];

     //רמת הרשאה 0.עדכון\הוספה\מחיקה 1.עיון בלבד
        if (self.user.permission === 1) {
            if (self._isAtidim === true) {
                this.displayedColumns = [
                  'companyName', 'firstName', 'lastName', 'carNumber', 'carNumber2', 'startDate', 'finishDate', 'phone', 'destinedPark', 'isReserved', 'reservedPark',
                  'isInSite', 'parkDescription', 'EntranceDate',
                  'editSubscriberAction', 'deleteSubscriberAction'
                ];
            }
            else {
              //---------------------
              if (this._isMobile === true) {
                this.displayedColumns = [
                  'lastName', 'divider1', 'carNumber', 'divider2', 'finishDate'
                ];
              }
              else {
                this.displayedColumns = [
                  'companyName', 'firstName', 'lastName', 'carNumber', 'startDate', 'finishDate', 'phone', 'isReserved', 'reservedPark', 'isInSite'
                  , 'parkDescription', 'EntranceDate'
                  //,'editSubscriberAction', 'deleteSubscriberAction'
                ];
              }
              //---------------------       
            }
        }
        else {
            if (self._isAtidim === true) {
                this.displayedColumns = [
                  'companyName', 'firstName', 'lastName', 'carNumber', 'carNumber2', 'startDate', 'finishDate', 'phone', 'destinedPark', 'isReserved', 'reservedPark', 'isInSite', 'parkDescription', 'EntranceDate',
                  'editSubscriberAction', 'deleteSubscriberAction'
                ];
            }
            else {
               //---------------------
              if (this._isMobile === true) {
                this.displayedColumns = [
                  'lastName', 'divider1', 'carNumber', 'divider2', 'finishDate'
                ];
              }
              else {
                this.displayedColumns = [
                  'companyName', 'firstName', 'lastName', 'carNumber', 'carNumber2', 'startDate', 'finishDate', 'phone', 'isReserved', 'reservedPark', 'isInSite'
                  , 'parkDescription', 'EntranceDate'
                  , 'editSubscriberAction', 'deleteSubscriberAction'
                ];
              }
              //--------------------       
            }
        }
    }

  getMaximumSubscribersToCreatePerPark() {

    const self = this;

    self._GuestsService.getMaximumSubscribersToCreatePerParks()
      .subscribe((data: MaxSubscribersToCreatePerPark[]) => {

        self._maxSubscribersToCreatePerParkList = data;

        if (self._maxSubscribersToCreatePerParkList) {

          self._subscribersAmoutLeftToCreateString = '0';
          self._subscribersAmoutToCreateString = '0';
          self._subscribersAmoutToCreateTotal = 0;

          self._maxSubscribersToCreatePerParkList.forEach((element) => {

            self._subscribersAmoutToCreateString += ' ' + element.parkDescription + ' - ' + element.maximumSubscribersWithDestinedParkToCreate;

            self._subscribersAmoutToCreateTotal += element.maximumSubscribersWithDestinedParkToCreate;

            //if (self._subscribersWithDestinedPark) {
            //  var t = self._subscribersWithDestinedPark.find(x => x.parkNumber == element.parkNumber);
            //  var leftToCreateTemp = element.maximumSubscribersWithDestinedParkToCreate - t.subscribersAmount;
            //  if (leftToCreateTemp < 0) leftToCreateTemp = 0;

            //  if (t) {
            //    self._subscribersAmoutLeftToCreateString += ' ' + element.parkDescription + ' - ' + (leftToCreateTemp).toString();
            //  }
            //  else {
            //    self._subscribersAmoutLeftToCreateString += ' ' + element.parkDescription + ' - ' + (element.maximumSubscribersWithDestinedParkToCreate).toString();
            //  }
            //}

          });


          self._subscribersAmoutLeftToCreateTotal = self._subscribersAmoutToCreateTotal - self._totalSubscribers;
          self._subscribersAmoutLeftToCreateString = self._subscribersAmoutLeftToCreateTotal.toString();

        }
      },
        error => { }
      );
  }


  parks() {

    const self = this;

    self._GuestsService.getParks()
      .subscribe((data: Park[]) => {

        

        self._parksList = data;
        var t = new Park();
        t.id = -1;
        t.parkDescription = 'כל החניונים';

        var t1 = new Park();
        t1.id = -2;
        t1.parkDescription = 'הצג הכל';

        self._parksList.push(t);
        self._parksList.push(t1);
        self._selectedPark = t1.id;


        self.getIfIsAtidim();

      },
        error => { }
      );
  }


  getIfIsAtidim() {

    const self = this;

    if (self._GuestsService._isAtidim == null) {

      self._GuestsService.getOverflowLevels()

        .subscribe((data: boolean) => {

          if (data === true) {

            self._GuestsService._isAtidim = true;
            self._isAtidim = true;

           // self.displayedColumns.splice(7, 0, 'destinedPark');
          }
          else {
            self._isAtidim = false;
            self._GuestsService._isAtidim = false;
          }

          this.setColumnsAccordingToAtidimAndUserPermissions();
        },
          error => { }
        );
    }
    else {
      if (self._GuestsService._isAtidim === true) {

        self._isAtidim = true;

       // self.displayedColumns.splice(7, 0, 'destinedPark');
      }
      else {
         self._isAtidim = false;

      }

      this.setColumnsAccordingToAtidimAndUserPermissions();
    }
  }




  filterInParkOnly1($event) {

    let self = this;

    if (this._selectedPark > 0 || this._selectedPark === -1 || this._selectedPark === -2) {

      self._GuestsService.getSubscriptions('', self.user.Id, this._pageNumber, this._pageSize)
        .subscribe((data: SubscribersGetResponse) => {
         
          self._amountPerSearch = data.amountPerSearch;
          self._totalSubscribers = data.amount;

          self._subscribersList = data.list;

          if (this._selectedPark > 0) {
            self._subscribersList = self._subscribersList.filter(x => x.insidePark > 0 && x.parkNumber === self._selectedPark).slice(0);
          }
          if (this._selectedPark === -1) {

            self._subscribersList = self._subscribersList.filter(x => x.insidePark > 0).slice(0);
          }

          self._selectedSubscriber = self._subscribersList[0];
        },
          error => { }
      );

    }
  }



  filterInSiteOnly() {

    if (this._filterInSiteOnly === true && this._selectedPark > 0) {
      this._subscribersList = this._subscribersList.filter(x => x.insidePark > 0 && x.parkNumber === this._selectedPark).slice(0);
    }
    else if (this._filterInSiteOnly === true) {
      this._subscribersList = this._subscribersList.filter(x => x.insidePark > 0).slice(0);
    }
    else {
     this.getSubscribersList('');
    }
  }

  getParksForReservedSubscriber() {

    const self = this;

    self._GuestsService.getParksForReservedSubscriber()
      .subscribe((data: ParkForReservedSubscriber[]) => {

        if (data) {
          self._parkForReservedSubscriberList = data;
         
        }
      },
        error => { }
      );
  }

  onSubscriberSelected(subscriber: Subscription) {
    const self = this;

    self._selectedSubscriber = subscriber;
  }

  onSeachClick() {
    this.getSubscribersList(this._searchByLPRNumber);
  }

  getCounting() {
    const self = this;

    self._GuestsService.getCounting()
      .subscribe((data) => {

        self.counting = data[0];
      },
        error => { }
      );
  }

  pageChanged(event: PageEvent) {
    
    this._pageNumber = event.pageIndex + 1;
    this.getSubscribersList(this._searchByLPRNumber);
  }

  getSubscribersList(searchBy: string) {

    const self = this;

    if (!searchBy) searchBy = '';

    try {
      if (this._lastCompany != this._GuestsService._selectedCompany.id) {
        this._lastCompany = this._GuestsService._selectedCompany.id;
        console.log("getSubscribersList PageNumber was : " + self._pageNumber);
        self._pageNumber = 1;
        if (self.paginator !== undefined) {
          self.paginator.firstPage();

        }
      }
    } catch (e) {
      console.error(e);
    }


    self._GuestsService.getSubscriptions(searchBy, self.user.Id, self._pageNumber, self._pageSize)
      .subscribe((data: SubscribersGetResponse) => {

        self._totalSubscribers = data.amount;
        self._amountPerSearch = data.amountPerSearch;
        self._subscribersList = data.list;
        self._selectedSubscriber = self._subscribersList[0];

        if (!this._searchByLPRNumber)
          self._AfterEmptySearch = true;
        else self._AfterEmptySearch = false;
       
        self._subscribersAmoutLeftToCreateTotal = 0;

        
        if (self._isAtidim && self._subscribersList && self._subscribersList.length > 0) {


          let subs = self.groupBy(self._subscribersList, x => x.destinedPark);

          self._subscribersWithDestinedPark = [];

          // get destined parks amounts
          subs.forEach((value, key) => {

            var subsAmount = new SubscribersWithDestinedParkAmounts();
            subsAmount.parkNumber = key;
            subsAmount.subscribersAmount = value.length;
            self._subscribersWithDestinedPark.push(subsAmount);

          });

          // get reserved parks amounts
          subs = self.groupBy(self._subscribersList, x => x.reservedParkID);

          subs.forEach((value, key) => {

            if (key > 0) {
              var sdp = self._subscribersWithDestinedPark.find(x => x.parkNumber == key);
              if (sdp) {
                sdp.subscribersAmount += value.length;
              }
              else {
                var subsAmount = new SubscribersWithDestinedParkAmounts();
                subsAmount.parkNumber = key;
                subsAmount.subscribersAmount = value.length;
                self._subscribersWithDestinedPark.push(subsAmount);
              }
            }
          });

        
        }

        
        if (self._GuestsService._isAtidim === true) {
          self.getMaximumSubscribersToCreatePerPark();
        }

      },
        error => { }
      );
  }

  groupBy(list, keyGetter) {

    const map = new Map();

    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }


  modifyPhoneNumber(phone: string): string {

    let modiefiedPhone: string;

    modiefiedPhone = '';

    let prefix: string;
    prefix = '+972';

    if (phone) {

      phone = phone.substring(1);

      modiefiedPhone = prefix + phone;
    }

    return modiefiedPhone;
  }

  onNewSubscriberClick() {

    // open dialog
    let self = this;
    //--------
    if (this._isMobile) {
      //~~~~~~~Refresh ~~~~
      this._EditSubscriberDialogModel = {
        subscription: new Subscription(),
        parksForReservedSubscriber: [],
        parksForDestinedSubscriber: [],
        isEdit: false,
        isAtidim: false,
        maxSubscribersToCreatePerParkList: [],
        subscribersWithDestinedPark: []
      }

      this._EditSubscriberDialogModel.subscription.isReservedPlace = false;
      this._startDate = new Date();
      this._endDate = new Date();
      this._endDate.setMonth(this._startDate.getMonth() + 1); // add month day to today
      //this.startTime = "00:00";
      //this.endTime = "00:00";      
      //~~~~~~~~~~~~~~~~~~~~
      this._showEditSubscriptionDialog = true;
      this._isNewSubscriber = true;
      this._selectedAction = SubscriptionAction.addNewSubscriber;
      this._EditSubscriberDialogModel.parksForReservedSubscriber = self._parkForReservedSubscriberList;
      this._EditSubscriberDialogModel.parksForDestinedSubscriber = self._parkForReservedSubscriberList;

    }
    else {
    //---------------
        this.dialogRef = this._dialog.open(EditSubscriberDialog, {
        width: '600px', height: '820px', direction: 'rtl', data: {
          subscription: new Subscription(),
          parksForReservedSubscriber: self._parkForReservedSubscriberList,
          parksForDestinedSubscriber: self._parkForReservedSubscriberList,
          isAtidim: self._isAtidim,
          isEdit: false,
          maxSubscribersToCreatePerParkList: self._maxSubscribersToCreatePerParkList,
          subscribersWithDestinedPark: self._subscribersWithDestinedPark
        }
      });

      const sub = this.dialogRef.componentInstance.OnSaveEvent.subscribe((data) => {
        console.log('EditSubscriberDialog validation before close ');

        this._selectedSubscriber = data;
        this._selectedSubscriber.userId = parseInt(this.user.Id);
        this.onNewSubscriberSave();
        
      });
      this.dialogRef.afterClosed().subscribe((result: Subscription) => {

        sub.unsubscribe();
        if (result) {
          self._selectedSubscriber = result;
          self._selectedSubscriber.userId = parseInt(self.user.Id);
          console.log('Subscriber afterClosed OnSaveEvent unsubscribe');
          //self.onNewSubscriberSave();
        }
      });
    }
  }

  //===============================

  onOutsideClick(event: Event) {
    this._isNewSubscriber = false;
    console.debug('Subscriptions onOutsideClick  ');
    if (!this.subscribersTable.nativeElement.contains(event.target)) {
      this._showEditSubscriptionDialog = false;
    }
  }
  //===============================

  onNewSubscriberSave() {

    let self = this;

    let model = new createEditSubscriberModel();
    model.carNo = self._selectedSubscriber.menuimCarNo;

    if (self._selectedSubscriber.menuimCarNo2)
      model.carNo2 = self._selectedSubscriber.menuimCarNo2;
    else model.carNo2 = '';

    model.endDate = self._selectedSubscriber.menuimEndDate;

    if (self._selectedSubscriber.isReservedPlace) {
      model.isReservedPlace = self._selectedSubscriber.isReservedPlace;
      model.reservedParkID = self._selectedSubscriber.reservedParkID;
    }
    else {
      model.isReservedPlace = false;
      model.reservedParkID = 0;

      model.destinedPark = self._selectedSubscriber.destinedPark;
    }

    model.lastName = self._selectedSubscriber.lastName;
    model.name = self._selectedSubscriber.name;
    
    model.startDate = self._selectedSubscriber.menuimStartDate;

    model.phone = self._selectedSubscriber.phone;
    model.phone = this.modifyPhoneNumber(model.phone);
    if (!model.phone) model.phone = '';

    model.subscriberID = 0;
    model.userId = self._selectedSubscriber.userId;

    model.companyID = self._GuestsService._selectedCompany.id;

    self._GuestsService.addSubscription(model)
      .subscribe((data) => {

        //--------
        this._isNewSubscriber = false;
        //--------

        if (data["error"]) {

          self._errorFromServer = data["errorMessage"];

          const dialogRef = this._dialog.open(MessageToUserDialog, {
            width: '600px', height: '200px', direction: 'rtl', data: { message: self._errorFromServer, isMobile: this._isMobile } // data: self._errorFromServer
          });
          //------------------------------
          return;
        }
        console.log('Subscribers onNewSubscriberSave returned OK  ');
        if (this.dialogRef !== undefined) {
          this.dialogRef.close();
        }
        this._showEditSubscriptionDialog = false;  // Close New/Edit Subscription mobile dialog
        self.getCounting();
        self.getSubscribersList('');
      },
        error => { }
      );
  }

  onEditSubscriberClick(subscriber: Subscription) {

    // open dialog
    let self = this;

    self._selectedSubscriber = subscriber;
    //----------
    if (this._isMobile) {
      this._showEditSubscriptionDialog = true;
      this._EditSubscriberDialogModel.subscription = self._selectedSubscriber;
      ///........
      try {
        this._EditSubscriberDialogModel.parksForReservedSubscriber = self._parkForReservedSubscriberList;
        this._EditSubscriberDialogModel.parksForDestinedSubscriber = self._parkForReservedSubscriberList;

        this._EditSubscriberDialogModel.isAtidim = self._isAtidim;
        this._EditSubscriberDialogModel.isEdit = true;
        this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList = self._maxSubscribersToCreatePerParkList;
        this._EditSubscriberDialogModel.subscribersWithDestinedPark = self._subscribersWithDestinedPark;


        this._startDate = new Date(this._EditSubscriberDialogModel.subscription.menuimStartDate);
        //this.startTime = this._EditSubscriberDialogModel.subscription.menuimStartDate.substring(11, 16);
        if (this._EditSubscriberDialogModel.subscription.menuimEndDate != null) {
          this._endDate = new Date(this._EditSubscriberDialogModel.subscription.menuimEndDate);
          //this.endTime = this._EditSubscriberDialogModel.subscription.menuimEndDate.substring(11, 16);
        }
        else {
          this._endDate = new Date();
          this._endDate.setMonth(this._startDate.getMonth() + 1); // add month day to today
        }
        if (this._EditSubscriberDialogModel.subscription.isReservedPlace === true) {
          this._selectedPark = this._EditSubscriberDialogModel.parksForReservedSubscriber.find(x => x.id === this._EditSubscriberDialogModel.subscription.reservedParkID).id;
          if (!this._selectedPark) {
            this._selectedPark = this._EditSubscriberDialogModel.parksForReservedSubscriber[0].id;
          }
        }
      }
      catch (e) {
        console.log(e);
      }
      ///........
      this._selectedAction = SubscriptionAction.editSubscriber;
    }
    else {
        this.dialogRef = this._dialog.open(EditSubscriberDialog, {
        width: '600px', height: '820px', direction: 'rtl', data: {
          subscription: self._selectedSubscriber,
          parksForReservedSubscriber: self._parkForReservedSubscriberList,
          parksForDestinedSubscriber: self._parkForReservedSubscriberList,
          isAtidim: self._isAtidim,
          isEdit: true,
          maxSubscribersToCreatePerParkList: self._maxSubscribersToCreatePerParkList,
          subscribersWithDestinedPark: self._subscribersWithDestinedPark
        }
      });
      const sub = this.dialogRef.componentInstance.OnSaveEvent.subscribe((data) => {
        console.log('onEditSubscriberClick validation before close ');

        this._selectedSubscriber = data;
        this._selectedSubscriber.userId = parseInt(this.user.Id);
        this.onEditSubscriberSave();

      });
      this.dialogRef.afterClosed().subscribe((result: Subscription) => {

        sub.unsubscribe();

        if (result) {
          self._selectedSubscriber = result;

          console.log('onEditSubscriberClick OnSaveEvent unsubscribe');
         //self.onEditSubscriberSave();
        }
        else {
          self.getSubscribersList('');
        }
      });
    }
    //----------
  }

  onEditSubscriberSave() {

    let self = this;

    let model = new createEditSubscriberModel();
    model.carNo = self._selectedSubscriber.menuimCarNo;

    if (self._selectedSubscriber.menuimCarNo2)
      model.carNo2 = self._selectedSubscriber.menuimCarNo2;
    else model.carNo2 = '';

    model.endDate = self._selectedSubscriber.menuimEndDate;

    if (self._selectedSubscriber.isReservedPlace) {
      model.isReservedPlace = self._selectedSubscriber.isReservedPlace;
      model.reservedParkID = self._selectedSubscriber.reservedParkID;
    }
    else {
      model.isReservedPlace = false;
      if (self._selectedSubscriber.reservedParkID)
        model.reservedParkID = self._selectedSubscriber.reservedParkID;
      else model.reservedParkID = 0;

      model.destinedPark = self._selectedSubscriber.destinedPark;
    }

    model.lastName = self._selectedSubscriber.lastName;
    model.name = self._selectedSubscriber.name;
   
    model.startDate = self._selectedSubscriber.menuimStartDate;

    model.phone = self._selectedSubscriber.phone;
    model.phone = this.modifyPhoneNumber(model.phone);
    if (!model.phone) model.phone = '';


    model.subscriberID = self._selectedSubscriber.menuimNo;
    model.userId = self._selectedSubscriber.userId;


    self._GuestsService.editSubscription(model)
      .subscribe((data) => {


        if (data["error"]) {

          self._errorFromServer = data["errorMessage"];

          const dialogRef = this._dialog.open(MessageToUserDialog, {
            width: '600px', height: '300px', direction: 'rtl', data: { message: self._errorFromServer, isMobile: this._isMobile } // data: self._errorFromServer
          });
          return;
        }
        console.log('onEditSubscriberSave returned OK  ');
        if (this.dialogRef !== undefined) {
          this.dialogRef.close();
        }
        this._showEditSubscriptionDialog = false;   // Close New/Edit Subscription mobile dialog
        self.getCounting();
        self.getSubscribersList('');
      },
        error => { }
      );
  }


  onDeleteSubscriberClick(subscriber: Subscription) {
    let self = this;// Save the value

    const dialogRef = this._dialog.open(MessageToUserDialog, {
      width: this._isMobile ? '400px' : '650px',
      height: '200px',
      direction: 'rtl',
      data: {
        message: this._isMobile ? 'AreUSureDeleteSubscriberMobile' : 'AreUSureDeleteSubscriber',
        isMobile: this._isMobile
      }
    });

    const promise = new Promise<boolean>((resolve) => {
      dialogRef.afterClosed().subscribe((result: boolean) => {
        resolve(result); // Resolve the promise when the dialog is closed
      });
    });

    promise.then((result: boolean) => {
      if (result === true) {
        // `_selectedGuest` will be available here
        //this.performAction(SubscriptionAction.deleteSubscriber);

        if (this._isMobile) {
          this._showEditSubscriptionDialog = false;
        }

        self.onDeleteSubscriberSave();
      }
    });
  }


  onDeleteSubscriberSave() {

    const self = this;

    self._GuestsService.deleteSubscription(self._selectedSubscriber.menuimNo)
      .subscribe((data) => {

        if (data["error"]) {

          self._errorFromServer = data["errorMessage"];
          console.log(self._errorFromServer);
          const dialogRef = this._dialog.open(MessageToUserDialog, {
            width: '600px', height: '300px', direction: 'rtl', data: { message: self._errorFromServer, isMobile: this._isMobile } // data: self._errorFromServer
          });
        }

        self.getCounting();
        self.getSubscribersList('');
      },
        error => { }
      );
  }


  isExpired(exitDate: string): boolean {

    let expired: boolean;
    expired = false;

    let datee = new Date(exitDate);
    if (datee < new Date()) {
      expired = true;
    }

    return expired;
  }

  //---------transferred functional from editSubscriber.dialog.ts----------
  onSaveClick(): void {


    this._EditSubscriberDialogModel.subscription.menuimStartDate = this.datePipe.transform(this._startDate, 'yyyy-MM-dd HH:mm');
    this._EditSubscriberDialogModel.subscription.menuimEndDate = this.datePipe.transform(this._endDate, 'yyyy-MM-dd HH:mm');

    if (this._EditSubscriberDialogModel.subscription.isReservedPlace === true) {
      this._EditSubscriberDialogModel.subscription.reservedParkID = this._selectedPark;

    }
    else {
      this._EditSubscriberDialogModel.subscription.destinedPark = this._selectedDestinedPark;
    }

    //==================
    if (this.InputFieldsAreValid() === true) {
      //this._showEditSubscriptionDialog = false;
      this._selectedSubscriber = this._EditSubscriberDialogModel.subscription;
      this._selectedSubscriber.userId = parseInt(this.user.Id);
      this.performAction(this._selectedAction);
    }
    else {
      // show alert
      console.log('Subscription Validation failed');

    }
    //====================
  }


  //=================
  onNoClick(): void {
    this._isNewSubscriber = false;
    if (this._isMobile) {
      this._showEditSubscriptionDialog = false;
      this._EditSubscriberDialogModel.isEdit = false;
      this._selectedPark = 0; /// ?~
      this._EditSubscriberDialogModel.subscription.isReservedPlace = false; /// ?~
    }
    console.debug('Subscriptions.ts onNoClick ');
    location.reload();
  }
  //=================


  InputFieldsAreValid(): boolean {


    this._errorString = '';

    const identityRe = /^-?\d+\.?\d*$/;
    if (this._EditSubscriberDialogModel.subscription.phone) {
      if (!identityRe.test(String(this._EditSubscriberDialogModel.subscription.phone))) {
        this._errorString = 'phoneNumberWrongFormat';
        return;
      }
      if (this._EditSubscriberDialogModel.subscription.phone.length !== 10) {
        this._errorString = 'phoneNumberWrongFormat';
        return;
      }
    }



    if (!this._EditSubscriberDialogModel.subscription.name) {
      this._errorString = 'FirstNameCantbeempty', 'error';
      return;
    }

    if (!this._EditSubscriberDialogModel.subscription.lastName) {
      this._errorString = 'LastNamecantbeempty', 'error';
      return;
    }

    if (!this._EditSubscriberDialogModel.subscription.menuimCarNo) {
      this._errorString = 'CarNumbercantbeempty', 'error';
      return;
    }

    const carRe = /^\d+$/;
    if (!carRe.test(this._EditSubscriberDialogModel.subscription.menuimCarNo)) {
      this._errorString = 'InvalidformatofCarNumber', 'error';
      return;
    }

    if (this._EditSubscriberDialogModel.subscription.menuimCarNo2) {
      if (!carRe.test(this._EditSubscriberDialogModel.subscription.menuimCarNo2)) {
        this._errorString = 'InvalidformatofCarNumber', 'error';
        return;
      }
    }

    if (!this._EditSubscriberDialogModel.subscription.menuimStartDate) {
      this._errorString = 'Datecantbeempty', 'error';
      return;
    }

    if (!this._EditSubscriberDialogModel.subscription.menuimEndDate) {

      this._errorString = 'EndDatecantbeempty', 'error';
      return;
    }

    if (this._endDate < new Date() || this._startDate < new Date(2000, 1, 1)) {

      this._errorString = 'DatesInvalid', 'error';
      return;
    }



    if (this._EditSubscriberDialogModel.isAtidim && this._EditSubscriberDialogModel.subscription.destinedPark <= 0 && this._EditSubscriberDialogModel.subscription.isReservedPlace === false) {
      this._errorString = 'DestinedParkCannotBeEmpty';
      return;
    }



    if (this._EditSubscriberDialogModel.isAtidim == true && this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList) {
      let subscribersWithDestinedPark_subscribersAmount: number;
      subscribersWithDestinedPark_subscribersAmount = 0;

      // destined
      if (this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList.length > 0 && this._EditSubscriberDialogModel.subscription.destinedPark > 0
        && this._EditSubscriberDialogModel.subscription.isReservedPlace == false) {

        if (this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList) {

          var t = this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList.find(x => x.parkNumber == this._EditSubscriberDialogModel.subscription.destinedPark);

          if (this._EditSubscriberDialogModel.subscribersWithDestinedPark) {
            var subscribersWithDestinedPark =
              this._EditSubscriberDialogModel.subscribersWithDestinedPark.find(x => x.parkNumber == this._EditSubscriberDialogModel.subscription.destinedPark);

            if (subscribersWithDestinedPark) subscribersWithDestinedPark_subscribersAmount = subscribersWithDestinedPark.subscribersAmount;
          }
          else subscribersWithDestinedPark_subscribersAmount = 0;



          if (t) {
            // new
            if (this._EditSubscriberDialogModel.isEdit === false && t.maximumSubscribersWithDestinedParkToCreate <= subscribersWithDestinedPark_subscribersAmount) {

              this._errorString = 'UnableToCreateMoreSubscribersFprDestinedPark';
              return;

            }
            else if (this._EditSubscriberDialogModel.isEdit === true && this._EditSubscriberDialogModel.subscription.isReservedPlace === false &&
              this._EditSubscriberDialogModel.subscription.reservedParkID === this._EditSubscriberDialogModel.subscription.destinedPark) {
              return true;
            }
            else if (this._EditSubscriberDialogModel.isEdit === true && this._EditSubscriberDialogModel.subscription.destinedPark !== this._originalSubscriberDestinedPark
              && t.maximumSubscribersWithDestinedParkToCreate <= subscribersWithDestinedPark_subscribersAmount) {

              this._errorString = 'UnableToCreateMoreSubscribersFprDestinedPark';
              return;
            }
            else {
              return true;
            }
          }
          else {
            return true;
          }
        }
      }

      // reserved
      if (this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList.length > 0 && this._EditSubscriberDialogModel.subscription.reservedParkID > 0
        && this._EditSubscriberDialogModel.subscription.isReservedPlace == true) {

        var t = this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList.find(x => x.parkNumber == this._EditSubscriberDialogModel.subscription.reservedParkID);

        var subscribersWithDestinedPark =
          this._EditSubscriberDialogModel.subscribersWithDestinedPark.find(x => x.parkNumber == this._EditSubscriberDialogModel.subscription.reservedParkID);

        if (subscribersWithDestinedPark) subscribersWithDestinedPark_subscribersAmount = subscribersWithDestinedPark.subscribersAmount;

        if (t) {
          // new
          if (this._EditSubscriberDialogModel.isEdit === false && t.maximumSubscribersWithDestinedParkToCreate <= subscribersWithDestinedPark_subscribersAmount) {

            this._errorString = 'UnableToCreateMoreSubscribersFprDestinedPark';
            return;

          }
          else if (this._EditSubscriberDialogModel.isEdit === true && this._EditSubscriberDialogModel.subscription.isReservedPlace === true &&
            this._EditSubscriberDialogModel.subscription.reservedParkID === this._originalSubscriberDestinedPark) {
            return true;
          }
          else if (this._EditSubscriberDialogModel.isEdit === true && this._EditSubscriberDialogModel.subscription.reservedParkID !== this._originalSubscriberReservedPark
            && t.maximumSubscribersWithDestinedParkToCreate <= subscribersWithDestinedPark_subscribersAmount) {

            this._errorString = 'UnableToCreateMoreSubscribersFprDestinedPark';
            return;
          }
          else {
            return true;
          }
        }
        else {
          return true;
        }
      }

    }

    else {
      return true;
    }
  }

  performAction(action: SubscriptionAction) {
    if (action === SubscriptionAction.addNewSubscriber) {
      this.onNewSubscriberSave();
    } else if (action === SubscriptionAction.editSubscriber) {
      this.onEditSubscriberSave();
    }
    else if (action === SubscriptionAction.deleteSubscriber) {
      this.onDeleteSubscriberSave();
    }
    //this._selectedAction = SubscriptionAction.None;
  }
  //-------------------------------------------------------------------------------------------
  endDatemodelchange(value) {
    console.debug('endDatemodelchange ' + value);          //Changed Value
    console.debug(this._endDate);  //undefined
  }
}

export enum SubscriptionAction {
  None = 0,
  addNewSubscriber = 1,
  editSubscriber = 2,
  deleteSubscriber = 3
}

export interface EditSubscriptionModel {
  subscription: Subscription,
  parksForReservedSubscriber: ParkForReservedSubscriber[],
  parksForDestinedSubscriber: ParkForReservedSubscriber[],
  isAtidim: boolean,
  isEdit: boolean,

  maxSubscribersToCreatePerParkList: MaxSubscribersToCreatePerPark[],

  subscribersWithDestinedPark: SubscribersWithDestinedParkAmounts[]
}
